module.exports = __webpack_public_path__ + "img/banner1.4cba38d9.jpg";